const sdkVersion =
  typeof __JESTSDK_VERSION__ === "string" && __JESTSDK_VERSION__.trim() !== ""
    ? __JESTSDK_VERSION__
    : "unknown";

export const SDK_VERSION = sdkVersion;
